// src/pages/Signup.js
import React, { useRef, useState, useEffect, useContext } from 'react';
import {
  getAuth,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile
} from 'firebase/auth';
import {
  getFirestore,
  updateDoc,
  doc,
  getDoc,
  setDoc,
  arrayUnion
} from 'firebase/firestore';
import { getDatabase, ref, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../AppContext';

const CustomCheckbox = ({ isChecked, onCheck }) => {
  return (
    <div onClick={onCheck} style={styles.checkboxBase}>
      {isChecked && <div style={styles.checkboxChecked} />}
    </div>
  );
};

export default function Signup() {
  const navigate = useNavigate();

  const auth = getAuth();
  const firestore = getFirestore();
  const database = getDatabase();

  const { setUser, setIsLoggedIn } = useContext(AppContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [accountType, setAccountType] = useState('Fan');
  const [location, setLocation] = useState('');
  const [country, setCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');

  const [validationError, setValidationError] = useState('');
  const [isSigningUp, setIsSigningUp] = useState(false);

  const [namePlaceholder, setNamePlaceholder] = useState('Name');

  const [termsModalVisible, setTermsModalVisible] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showVerifyPrompt, setShowVerifyPrompt] = useState(false);

  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  useEffect(() => {
    switch (accountType) {
      case 'Artist':
        setNamePlaceholder('Artist Name');
        break;
      case 'Producer':
        setNamePlaceholder('Producer Name');
        break;
      case 'RecordLabel':
        setNamePlaceholder('Record Label Name');
        break;
      case 'Songwriter':
        setNamePlaceholder('Songwriter Name');
        break;
      case 'SPNCaster':
        setNamePlaceholder('SPNCaster Name');
        break;
      case 'Band':
        setNamePlaceholder('Band Name');
        break;
      default:
        setNamePlaceholder('Name');
    }
  }, [accountType]);

  const statesList = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' }
  ];

  const countryList = [
    { label: 'United States', value: 'US' },
    { label: 'United Kingdom', value: 'UK' },
    { label: 'Canada', value: 'CA' },
    { label: 'Australia', value: 'AU' },
    { label: 'Germany', value: 'DE' },
    { label: 'Sweden', value: 'SE' },
    { label: 'France', value: 'FR' },
    { label: 'Brazil', value: 'BR' },
    { label: 'Japan', value: 'JP' },
    { label: 'Netherlands', value: 'NL' }
  ];

  const DISPLAY_TEXT =
    "TERMS OF SERVICE\n" +
    "SPNDAT INC.\n\n" +
    "These Terms of Service (the \"Terms\") govern your access to use the SPNDAT social media platform, including all features, functionalities, and services (collectively, the \"Service\") and your use of the music and video jukebox component of the software application (the \"App\") offered by SPNDAT, Inc. (\"SPNDAT\", \"us\" or \"we\"). By accessing or using the App and/or the Service, you (\"you\" or the \"user\") agree to be bound by these Terms and our Privacy Policy.\n\n" +
    "1. Your Account\n" +
    "   a. Use of the App. The App allows you to play and purchase music and video, as well as listen to free music provided by the App's library. You may use the App for personal or commercial purposes. You may not use the App for any illegal or unauthorized purpose.\n" +
    "   b. Use of the Service. The Service allows you to send messages, post content, and follow other users. You are solely responsible for the content of your messages and posts (\"User Content\"). You agree not to post or send any content that is illegal, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable. You agree not to engage in any activity that interferes with or disrupts the Service, including the servers and networks connected to the Service.\n" +
    "   c. Account Requirements. By using the App and/or Service, you represent and agree to the following conditions and requirements:\n" +
    "      i. You must be at least 13 years old to use the App and/or Service. By creating an account, you represent that you are at least 13 years old and have the legal capacity to enter into these Terms.\n" +
    "      ii. You are responsible for maintaining the confidentiality of your account and your password and for restricting access to your account.\n" +
    "      iii. You agree to accept sole responsibility and liability for all activities that occur under your account.\n" +
    "      iv. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.\n" +
    "      v. You agree not to use the Service for any illegal or unauthorized purpose.\n" +
    "   d. Account Types. SPNDAT offers multiple types of accounts, including User Accounts and Vendor Accounts. By creating or using a User Account or Vendor Account, you agree to the following:\n" +
    "      i. User Accounts. We may offer, in our sole discretion, for you to create, access, and use a User Account. User Accounts are authorized to send messages, post content, and follow other users. User Accounts are further authorized to access Vendor Content (defined herein) only in accordance with these Terms and other requirements put in place by Vendor Account owners.\n" +
    "      ii. Vendor Accounts. We may offer, in our sole discretion, for you to create and use a Vendor Account. Vendor Accounts are authorized to provide sound recordings, music videos, musical performances, and other intellectual property (\"Vendor Content\") for distribution and commercial exploitation through the App. Vendor accounts shall include any Artist, SPNcaster, Producer, DJ, and record label accounts. All SPNDAT vendor accounts are charged an 8% fee on all financial transactions throughout the app. SPNDAT is not responsible for any reimbursements to you; all sales and transactions are final. By providing any Vendor Content to SPNDAT, you assert and affirm that you are the owner of the Vendor Content or otherwise authorized to license the Vendor Content in accordance with these Terms.\n\n" +
    "2. Intellectual Property\n" +
    "   a. Our Intellectual Property. The App and/or Service and its original content, features, and functionality are owned by SPNDAT INC. and are protected by copyright, trademark, and other intellectual property laws. You agree not to reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on the App and/or Service, except as necessary for your own personal, non-commercial use. SPNDAT has the right to remove any User Content or Vendor Content provided to the app unlawfully for any reason, without notice.\n" +
    "   b. User Content. You hereby grant to SPNDAT a license to reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the User Content that you provide to SPNDAT via the Service without limitation.\n" +
    "   c. Vendor’s Content. You understand and acknowledge that any music or other intellectual property made available on the App by Vendor Account holders is subject to copyright protection. Any account that is not a Vendor Account may only use Vendor Content for personal, non-commercial purposes, as provided in the context of the App. You agree not to modify, reproduce, distribute, transmit, display, perform, or create derivative works from any Vendor Content without the express permission of the copyright owner, and hold SPNDAT INC. harmless against any content or copyright infringements. You are solely responsible, and SPNDAT is explicitly not responsible, for any royalties, licenses, agreements, or claims associated with the provided Vendor Content.\n" +
    "   d. Copyright Complaint Notice. Any party who believes that their work has been copied in a way that constitutes copyright infringement should notify us of their infringement claim in accordance with the procedure set forth herein. We will process and investigate notices of alleged infringement and take appropriate actions under the Digital Millennium Copyright Act (\"DMCA\") with respect to any alleged or actual infringement. A notification of claimed copyright infringement should be emailed to the following address with the subject line \"DMCA Takedown Request\":\n\n" +
    "SPNDAT Inc.’s Copyright Agent\n" +
    "support@spndat.com\n" +
    "2025 S McCall Road,\n" +
    "Englewood, FL 34223\n\n" +
    "      i. Notification Requirements. To be effective, the notification must be in writing and contain the following information:\n" +
    "         1. A physical or electronic signature of a person authorized to act on behalf of the owner of the copyright or other intellectual property interest that is allegedly infringed;\n" +
    "         2. Identification of the copyrighted work or other intellectual property that you claim has been infringed, or, if multiple copyrighted works are covered by a single notification, a list identifying such works or other intellectual property;\n" +
    "         3. Identification of the content that is claimed to be infringing or to be the subject of infringing activity, including where the content that is claimed to be infringing is located, with sufficient detail that SPNDAT may locate it;\n" +
    "         4. The notifying party’s address, telephone number, and email address; and\n" +
    "         5. A statement affirming good-faith belief that the disputed use is not authorized by the copyright or intellectual property owner, its agent, or the law; that the information in your notice is accurate and, under penalty of perjury, that the notifying party is the copyright or intellectual property owner or is authorized to act on the behalf of the owner of the copyright or intellectual property that is allegedly infringed.\n" +
    "      ii. Counter-Notice. If a party believes that their content that was removed (or to which access was disabled) is not infringing, or that they have the authorization from the copyright owner, from the copyright owner's agent, or pursuant to the law, to upload and use the intellectual property in content, such party may send a written counter-notice containing the following information to the Copyright Agent:\n" +
    "         • The party’s physical or electronic signature;\n" +
    "         • Identification of the content that has been removed or to which access has been disabled, including the location at which the content appeared before it was removed or disabled;\n" +
    "         • A statement by the party, made under penalty of perjury, affirming they have a good-faith belief that the content was removed or disabled as a result of mistake or a misidentification of the content to be removed or disabled;\n" +
    "         • The party’s name, address, telephone number, and email address; and\n" +
    "         • A statement consenting to the jurisdiction of the federal court located within Tennessee and a statement that the party will accept service of process from the person who provided notification of the alleged infringement.\n" +
    "      iii. Repeat Infringement. In accordance with the DMCA and other applicable law, we may, at our sole discretion, terminate the accounts of users deemed to be repeat infringers. We may also, in our sole discretion, limit access to the Service and/or terminate the accounts of any users who infringe any intellectual property rights of others, whether or not there is any repeat infringement.\n\n" +
    "3. Prohibited Conduct. You agree not to use the App in any way that violates any applicable laws or regulations. You agree not to use the App to transmit any content that is illegal, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable.\n\n" +
    "4. Termination. We reserve the right to terminate or suspend your account and access to the App and/or Service at any time and for any reason, without notice.\n\n" +
    "5. Governing Law. These Terms shall be governed by and construed in accordance with the laws of the state of Tennessee, without regard to its conflict-of-law principles.\n\n" +
    "6. Changes to Terms. We reserve the right to modify or revise these Terms at any time. We will notify you of any changes by posting the new Terms for the App and/or Service.\n\n" +
    "7. Disclaimers. By choosing to follow users of the SPNDAT platform, you are allowing those you follow to send you direct marketing info which include, but are not limited to, direct messages, images, special offers, and promotions. You can opt out of receiving information from any user on the SPNDAT platform by simply unfollowing that user and/or content provider. In addition, if at any point you have received content that you deem inappropriate or a violation of these Terms, you agree to report this violation to SPNDAT using the report tool. By deactivating an account, all data associated with that account will be lost. This includes, but is not limited to, personal information and unclaimed money.\n\n" +
    "8. Disclaimer of Warranty. The App is provided \"as is\" and \"as available\" without warranties of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, or non-infringement.\n\n" +
    "9. Limitation of Liability; Waiver of Jury Trial. EXCEPT FOR EACH PARTY’S INDEMNIFICATION OBLIGATIONS HEREUNDER, NEITHER PARTY WILL BE LIABLE TO THE OTHER PARTY FOR ANY SPECIAL, INDIRECT, CONSEQUENTIAL, EXEMPLARY, PUNITIVE OR INCIDENTAL DAMAGES WHATSOEVER (INCLUDING LOST RIGHTS, PROFITS OR GOODWILL, BUSINESS INTERRUPTION, REPUTATIONAL DAMAGE AND THE LIKE) ARISING OUT OF OR IN CONNECTION WITH THE PERFORMANCE, NON-PERFORMANCE OR BREACH OF THIS AGREEMENT.\n\n" +
    "EACH PARTY ACKNOWLEDGES AND AGREES THAT ANY DISPUTE RELATING TO OR ARISING OUT OF THIS AGREEMENT IS LIKELY TO INVOLVE COMPLICATED AND DIFFICULT ISSUES, AND THEREFORE, EACH PARTY KNOWINGLY, INTENTIONALLY, IRREVOCABLY AND UNCONDITIONALLY WAIVES ANY RIGHT SUCH PARTY MAY HAVE HAD TO A TRIAL BY JURY IN RESPECT OF ANY SUCH DISPUTE.\n\n" +
    "NOTWITHSTANDING THE FOREGOING, IN NO EVENT SHALL SPNDAT BE LIABLE TO OWNER FOR ANY MONETARY DAMAGES GREATER THAN THE AMOUNT ACTUALLY EARNED BY OWNER, INCLUSIVE OF DAMAGES, ATTORNEY’S FEES AND COSTS, IF APPLICABLE, FOR ANY CAUSE AND REGARDLESS OF THE FORM OF THE ACTION TAKEN.\n\n" +
    "10. Dispute Resolution. Except to the extent that any applicable additional terms incorporated into these Terms provide differently or the applicable laws and regulation of your jurisdiction mandate otherwise, use of the App and/or Service and these Terms shall be governed by and construed in accordance with the laws of Tennessee.\n\n" +
    "Any dispute, controversy, or difference of opinion arising out of or in connection with the Agreement which cannot be settled amicably by parties to the Agreement (each a \"Claim\" and collectively \"Claims\"), including any question as to the validity, existence, or termination of these Terms of Use, shall be referred to and finally resolved by arbitration under the Commercial Arbitration Rules (the \"AAA Rules\") of the American Arbitration Association (\"AAA\") in effect at the time the arbitration is initiated and modified by the terms set forth in this Arbitration Agreement and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (\"AAA Consumer Rules\").\n\n" +
    "11. Arbitration. To expedite resolution and reduce the cost of any Claim, you and SPNDAT agree to first attempt to negotiate any Claim (except those Claims expressly excluded below) informally for at least thirty (30) days before initiating any arbitration or court proceeding. Such informal negotiations will commence upon written notice. If necessary to preserve a Claim under any applicable statute of limitations, you or SPNDAT may initiate arbitration while engaging in the informal negotiations.\n\n" +
    "YOU AND SPNDAT MUTUALLY AGREE TO WAIVE YOUR RESPECTIVE RIGHTS TO RESOLUTION OF ALL CLAIMS BETWEEN YOU (EXCEPT THOSE EXPRESSLY EXCLUDED BELOW) IN A COURT OF LAW BY A JUDGE OR JURY AND AGREE TO RESOLVE ANY DISPUTES BY BINDING ARBITRATION ON AN INDIVIDUAL BASIS AS SET FORTH HEREIN.\n\n" +
    "This agreement to arbitrate (this \"Arbitration Agreement\") is governed by the Federal Arbitration Act and survives the termination of the Agreement or your relationship with SPNDAT. Claims include, but are not limited to, any dispute, claim, or controversy whether based on past, present, or future events arising out of or relating to: the Agreement and prior versions, the App and/or Service, your relationship with SPNDAT, the threatened or actual suspension, deactivation or termination of your Account or the Agreement, payments made by you or any payments made or allegedly owed to you, fraud, defamation, trade secrets, unfair competition, emotional distress, any promotions, offers made by SPNDAT, breach of any express or implied contract or covenant, claims arising under federal or state consumer protection laws, antitrust laws, the Telephone Consumer Protection Act, the Fair Credit Reporting Act, the Civil Rights Act of 1964, the Uniform Trade Secrets Act, the Americans With Disabilities Act, and all other federal and state statutory and common-law claims.\n\n" +
    "12. Class Actions. You and SPNDAT agree that any arbitration will be limited to the Claim between SPNDAT and you individually. YOU ACKNOWLEDGE AND AGREE THAT YOU AND SPNDAT ARE EACH WAIVING THE RIGHT TO PARTICIPATE AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS ACTION OR REPRESENTATIVE PROCEEDING (\"CLASS ACTION WAIVER\").\n\n" +
    "13. Arbitration Fees. The arbitrator will decide the substance of all Claims in accordance with applicable law and will honor all claims of privilege recognized by law. Your arbitration fees and your share of arbitrator compensation will be governed by the AAA Rules (and, where appropriate, limited by the AAA Consumer Rules) subject to the modifications set forth herein.\n\n" +
    "14. Claims Excluded. The following types of Claims are not required to be arbitrated under this Arbitration Agreement (\"Excluded Claims\"):\n" +
    "   • Small claims actions that are within the scope of small claims court jurisdiction and brought on an individual basis;\n" +
    "   • Claims that may not be subject to arbitration as a matter of law.\n\n" +
    "Nothing in this Arbitration Agreement prevents you from making a report to or filing a claim or charge with any federal, state, or local government agency, nor from receiving an award for information provided to any government agencies.\n\n" +
    "15. Miscellaneous:\n" +
    "   a. Doxing Protocol. \"Doxing\" shall include, but not be limited to, publicly providing personally identifiable information about an individual or organization via the Internet without their consent. Anyone who attempts to dox another user or display another user's personally identifiable information without their consent will be terminated immediately without notice.\n" +
    "   b. Breach and Waiver. A waiver of any breach of these Terms in any one instance will not constitute a waiver of any subsequent breach, whether or not similar.\n" +
    "   c. Taxes. You shall be solely responsible for and pay your tax obligations.\n" +
    "   d. Severance. In the event of any conflict between any provision of these Terms and any present or future statute, law, ordinance, or regulation, the latter will prevail, but in such event, the provision of these Terms affected will be severed and limited only to the extent necessary to bring it within legal requirements.\n" +
    "   e. Assignment. We may fully and freely transfer, designate, assign, and license, in whole or in part, without restriction, the rights granted to us under these Terms. Neither these Terms nor any of your rights or responsibilities under these Terms may be assigned or otherwise transferred by you without our prior written consent.\n\n" +
    "16. Contact Us. If you have any questions about these Terms, please contact us at support@spndat.com. Write to us at:\n" +
    "SPNDAT Inc.\n" +
    "2025 S McCall Road,\n" +
    "Englewood, FL 34223\n";

  // Street Flavor mandatory follow (from your requirement)
  const mandatoryFollowingIds = [ 
    "h0fEIStkM4XHTDErZM5i8XIo9rA3",
    "OHaY20b54nTGd5BBgbJOL2BHEbX2",
    "rdX289s3YBP31Hw5qn2eXVywtBq1", 
    "Mkf4631LCEOYmHXWRzGirPdxBrt1"
  ];

  const blockedDomains = ['maskmsn.cc', 'masn.com'];

  const CustomButton = ({ onClick, title, textStyle, buttonStyle, disabled }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        ...styles.button,
        ...(buttonStyle || {}),
        opacity: disabled ? 0.6 : 1
      }}
    >
      <span style={{ ...styles.buttonText, ...(textStyle || {}) }}>{title}</span>
    </button>
  );

  const handleSignupPress = async () => {
    setTermsModalVisible(true);
  };

  const handleAgreeAndCreateAccount = async () => {
    if (!termsAccepted) {
      setValidationError('You must accept the Terms and Conditions to create an account.');
      return;
    }

    const emailDomain = email.split('@')[1]?.toLowerCase();
    if (emailDomain && blockedDomains.includes(emailDomain)) {
      setValidationError('This email domain is not allowed.');
      return;
    }

    setValidationError('');
    setIsSigningUp(true);

    if (!email || !password || !confirmPassword || !username || !name) {
      setValidationError('Please fill in all mandatory fields.');
      setIsSigningUp(false);
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setValidationError('Invalid email format.');
      setIsSigningUp(false);
      return;
    }

    if (password !== confirmPassword) {
      setValidationError('Passwords do not match.');
      setIsSigningUp(false);
      return;
    }

    if (name.length > 30 || username.length > 30) {
      setValidationError('Name and username must be less than 30 characters.');
      setIsSigningUp(false);
      return;
    }

    try {
      // 1) Create Auth user
      const cred = await createUserWithEmailAndPassword(auth, email, password);
      const user = cred.user;

      // 2) Update profile with displayName (username)
      try {
        await updateProfile(user, { displayName: username });
      } catch (e) {
        console.warn('updateProfile failed:', e?.message || e);
      }

      // 3) Reserve username (fail if taken)
      const usernameLowerCase = username.toLowerCase();
      const usernameRef = doc(firestore, 'usernames', usernameLowerCase);
      const usernameSnapshot = await getDoc(usernameRef);
      if (usernameSnapshot.exists()) {
        setValidationError('Username already taken');
        setIsSigningUp(false);
        return;
      }
      await setDoc(usernameRef, { uid: user.uid });

      // 4) Create Firestore user doc
      const userState = country === 'US' ? selectedState : country;
      const baseUserDoc = {
        id: user.uid,
        userId: user.uid,
        email,
        name,
        ArtistName: name,
        ArtistNameLower: name.toLowerCase(),
        username,
        username_lower: usernameLowerCase,
        location,
        accountType,
        profileImageUrl: '',
        lastOperationTime: new Date(),
        following: [...mandatoryFollowingIds],
        // Street Flavor extras (safe defaults)
        purchaseHistory: [],
        salesHistory: [],
        uploadedItems: [],
        purchasedItems: [],
        state: userState
      };

      // For non-Fan accounts, mirror SPNDAT structure fields
      if (accountType !== 'Fan') {
        baseUserDoc.albums = [];
        baseUserDoc.singles = [];
        baseUserDoc.videos = [];
        baseUserDoc.videoalbums = [];
      }

      await setDoc(doc(firestore, 'users', user.uid), baseUserDoc);

      // 5) Seed RTDB basics (credits, simple stats)
      await set(ref(database, `users/${user.uid}/credits`), 0);
      await set(ref(database, `users/${user.uid}/stats`), {
        totalSpns: 0,
        sales: { singles: 0, albums: 0, videos: 0 }
      });

      // 6) Add this user to followers of mandatory account(s)
      await Promise.all(
        mandatoryFollowingIds.map(id =>
          updateDoc(doc(firestore, 'users', id), { followers: arrayUnion(user.uid) })
        )
      );

      // 7) Send verification, then sign out
      await sendEmailVerification(user, { url: `${window.location.origin}/login` });
      await auth.signOut();

      // 8) Local state + route with banner
      setShowVerifyPrompt(true);
      setIsSigningUp(false);
      setIsLoggedIn(false);
      setUser(null);
      navigate('/login', { state: { showVerifyBanner: true, email } });
    } catch (error) {
      console.error('Signup error:', error);
      setValidationError(error.message || 'Signup failed');
      setIsSigningUp(false);
    }
  };

  return (
    <>
      <div style={styles.pageWrap}>
        <div style={styles.form}>
          <h1 style={styles.header}>Create Account</h1>

          {validationError ? <p style={styles.error}>{validationError}</p> : null}

          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            style={styles.input}
            ref={passwordRef}
            type="password"
            placeholder="Password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <input
            style={styles.input}
            ref={confirmPasswordRef}
            type="password"
            placeholder="Confirm Password"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />

          <input
            style={styles.input}
            type="text"
            placeholder={namePlaceholder}
            value={name}
            onChange={(e) =>
              setName(
                e.target.value.replace(/[^a-zA-Z0-9\s]/g, '').substring(0, 30)
              )
            }
          />

          {accountType === 'Artist' && (
            <p style={styles.smallText}>
              This Artist Name will appear on your releases and cannot be changed.
            </p>
          )}

          <input
            style={styles.input}
            type="text"
            placeholder="@Username"
            value={username}
            onChange={(e) =>
              setUsername(
                e.target.value.replace(/[^a-zA-Z0-9]/g, '').substring(0, 25)
              )
            }
          />

          <input
            style={styles.input}
            type="text"
            placeholder="City"
            value={location}
            onChange={(e) => setLocation(e.target.value.substring(0, 17))}
          />

          <select
            style={styles.select}
            value={country}
            onChange={(e) => {
              setCountry(e.target.value);
              if (e.target.value !== 'US') setSelectedState('');
            }}
          >
            <option value="">Select your country (optional)...</option>
            {countryList.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>

          {country === 'US' && (
            <select
              style={styles.select}
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
            >
              <option value="">Select your state (optional)...</option>
              {statesList.map((s) => (
                <option key={s.value} value={s.value}>{s.label}</option>
              ))}
            </select>
          )}

          <label style={styles.label}>Account Type</label>
          <select
            style={styles.select}
            value={accountType}
            onChange={(e) => setAccountType(e.target.value)}
          >
            <option value="Fan">Personal</option>
            <option value="Artist">Artist</option>
            <option value="Band">Band</option>
            <option value="RecordLabel">Record Label</option>
            <option value="Producer">Producer</option>
            <option value="Songwriter">Songwriter</option>
            <option value="SPNCaster">SPNCaster</option>
            <option value="Filmmaker">Filmmaker</option>
            <option value="Director">Director</option>
            <option value="Actor">Actor</option>
          </select>

          <CustomButton
            title={isSigningUp ? 'Creating Account…' : 'Create Account'}
            onClick={handleSignupPress}
            textStyle={{ color: '#000' }}
            buttonStyle={styles.primaryButton}
            disabled={isSigningUp}
          />

          <CustomButton
            title="Already have an account? Login"
            onClick={() => navigate('/login')}
            textStyle={{ color: '#f5c65d' }}
            buttonStyle={styles.ghostButton}
          />
        </div>
      </div>

      {termsModalVisible && (
        <div style={styles.centeredView}>
          <div style={styles.modalView}>
            <div style={styles.scrollView}>
              <p style={styles.modalText}>{DISPLAY_TEXT}</p>
            </div>
            <div style={styles.checkboxContainer}>
              <CustomCheckbox
                isChecked={termsAccepted}
                onCheck={() => setTermsAccepted(!termsAccepted)}
              />
              <p style={{ marginLeft: 8, color: '#fff' }}>
                I agree to the Privacy Policy, Terms and Conditions
              </p>
            </div>
            <button
              style={styles.buttonClose}
              onClick={() => {
                setTermsModalVisible(false);
                handleAgreeAndCreateAccount();
              }}
            >
              Agree and Create Account
            </button>
            <button
              style={styles.buttonClose}
              onClick={() => setTermsModalVisible(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {showVerifyPrompt && (
        <div style={styles.verifyBanner}>
          📬 We’ve sent a verification link to {email}. Please check your inbox and
          click the link before you log in.
        </div>
      )}
    </>
  );
}

const styles = {
  pageWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh',
    backgroundColor: '#000',
    paddingTop: 60
  },
  form: {
    width: '90%',
    maxWidth: 460,
    backgroundColor: '#000',
    padding: 20,
    borderRadius: 10,
    border: '1px solid rgba(245, 198, 93, 0.25)',
    boxSizing: 'border-box',
    margin: '0 auto'
  },
  header: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: 16,
    textAlign: 'center',
    color: '#fff'
  },
  input: {
    width: '100%',
    height: 44,
    border: '1px solid #333',
    margin: '0 0 14px 0',
    padding: '8px 10px',
    fontSize: '1rem',
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.08)',
    borderRadius: 6,
    outline: 'none',
    display: 'block',
    boxSizing: 'border-box'
  },
  select: {
    width: '100%',
    height: 44,
    border: '1px solid #333',
    margin: '0 0 14px 0',
    padding: '8px 10px',
    fontSize: '1rem',
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.08)',
    borderRadius: 6,
    outline: 'none'
  },
  label: {
    color: '#fff',
    margin: '6px 0'
  },
  smallText: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: '0.85rem',
    marginTop: -6,
    marginBottom: 12,
    textAlign: 'left'
  },
  error: {
    color: '#ff6b6b',
    marginBottom: 12,
    fontSize: '0.95rem'
  },
  button: {
    padding: 12,
    borderRadius: 6,
    textAlign: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    width: '100%',
    boxSizing: 'border-box',
    cursor: 'pointer',
    border: '1px solid #f5c65d',
    transition: 'transform 120ms ease'
  },
  buttonText: {
    fontSize: '1rem',
    color: '#fff'
  },
  primaryButton: {
    backgroundColor: '#f5c65d',
    borderColor: '#f5c65d',
    marginBottom: 14
  },
  ghostButton: {
    backgroundColor: 'transparent',
    borderColor: '#f5c65d',
    marginBottom: 12
  },
  centeredView: {
    position: 'fixed',
    overflow: 'hidden',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.6)',
    zIndex: 999
  },
  modalView: {
    width: '90%',
    maxWidth: 560,
    maxHeight: '80vh',
    backgroundColor: '#0b0b0b',
    borderRadius: 10,
    padding: 18,
    textAlign: 'center',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    border: '1px solid rgba(245, 198, 93, 0.25)'
  },
  scrollView: {
    maxHeight: '60vh',
    overflowY: 'auto',
    marginBottom: 16,
    padding: 10,
    border: '1px solid #222',
    borderRadius: 6,
    width: '100%',
    color: 'white',
    textAlign: 'left',
    backgroundColor: 'rgba(255,255,255,0.03)'
  },
  modalText: {
    color: 'white',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.35,
    fontSize: '0.95rem'
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10
  },
  checkboxBase: {
    width: 22,
    height: 22,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#fff',
    borderStyle: 'solid',
    borderRadius: 4,
    cursor: 'pointer'
  },
  checkboxChecked: {
    width: 12,
    height: 12,
    backgroundColor: '#fff'
  },
  buttonClose: {
    backgroundColor: 'transparent',
    borderRadius: 6,
    padding: 12,
    marginTop: 8,
    cursor: 'pointer',
    color: '#f5c65d',
    fontSize: 16,
    border: '1px solid #f5c65d',
    width: '100%'
  },
  verifyBanner: {
    position: 'fixed',
    bottom: 16,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(245, 198, 93, 0.08)',
    border: '1px solid #f5c65d',
    color: '#f5c65d',
    padding: '10px 14px',
    borderRadius: 6,
    textAlign: 'center',
    fontSize: '0.95rem',
    fontWeight: 500,
    zIndex: 1000
  }
};
